import { render, staticRenderFns } from "./HelloFooter.vue?vue&type=template&id=d5c8dd10&scoped=true"
import script from "./HelloFooter.vue?vue&type=script&lang=js"
export * from "./HelloFooter.vue?vue&type=script&lang=js"
import style0 from "./HelloFooter.vue?vue&type=style&index=0&id=d5c8dd10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c8dd10",
  null
  
)

export default component.exports